import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import Header from '../../components/Header'
import Sidebar from '../../components/Sidebar'
import Table from '../../components/Table/Table'
import Modal from '../../components/Modal'
import {
  InventoryInputModal,
  InventoryOutputModal,
  HistoricModal
} from '../../components/Inventory'
import { Grid, Content } from '../../components/Layout'
import { Button } from '../../components/Form'
import ResponsiblesContent from '../../components/ResponsiblesContent'
import statusSuccessIcon from '../../assets/icons/status-success.svg'
import statusWarningIcon from '../../assets/icons/status-warning.svg'
import historicIcon from '../../assets/icons/history-solid.svg'
import editIcon from '../../assets/icons/edit.svg'
import { pxToRem, color } from '../../utils'
import { inventoryActions } from '../../actions'
import ContentHeader from '../../components/ContentHeader'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''

const WrapperButton = styled.div`
  margin-bottom: ${pxToRem(10)};
  display: block;
  text-align: right;
  width: 100%;
  div {
    vertical-align: bottom;
  }
`

const WrapperExportButton = styled.div`
  float: left;
  display: block;
`

const WrapperExport = styled.div`
  float: left;
  h2 {
    font-size: ${pxToRem(16)};
    display: block;
    margin-top: 0;
    margin-bottom: 0;
  }
`

const ExportLink = styled.i`
  cursor: pointer;
  font-size: ${pxToRem(16)};
  color: ${color.secondary};
  display: inline-block;
  text-decoration: underline;
  &:visited {
    color: ${color.secondary};
  }
`

const ExportXls = styled(ExportLink)`
  margin-right: 5px;
`

const ExportPdf = styled(ExportLink)`
  margin-left: 5px;
`

const InputButton = styled(Button)`
  margin-right: 5px;
  background-color: #4a90e2;
  border: 1px solid #4a90e2;
`

const OutputButton = styled(Button)`
  margin-left: 5px;
  background-color: #e84d4d;
  border: 1px solid #e84d4d;
`

const WarningWrapper = styled.div`
  color: #5b666d;
  min-height: ${pxToRem(240)};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    text-align: center;
  }
  strong {
    font-size: ${pxToRem(14)};
    text-align: center;
  }
`

const WrapperStatus = styled.div`
  width: 20px;
  height: 20px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }
  ${({ type }) => {
    return `
      background: ${type === 'success' ? color.success : color.warning}
      img{
        width: ${type === 'success' ? pxToRem('15px') : pxToRem('5px')}
      }
    `
  }};
`

const InventoryLink = styled.a`
  color: ${color.secondary};
  text-transform: uppercase;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
`

const WrapperActions = styled.div`
  text-align: center;
`

const Action = styled.img`
  width: ${pxToRem('25px')};
  height: 20px;
  margin: 5px;
  display: inline-block;
  cursor: pointer;
`

const StockContent = styled.div``

const columns = {
  id: {
    hide: true
  },
  product_id: {
    hide: true
  },
  observation: {
    hide: true
  },
  amount: {
    hide: true
  },
  amount_package: {
    hide: true
  },
  product_measure_description: {
    hide: true
  },
  minimum_stock: {
    hide: true
  },
  cabinets: {
    hide: true
  },
  name: {
    label: 'Produto',
    width: pxToRem(600)
  },
  batch: {
    label: 'Lote / Identificação',
    sortable: true,
    width: pxToRem(100)
  },
  manufacturing_date: {
    label: 'Fabricação',
    sortable: true,
    width: pxToRem(100)
  },
  expiration_date: {
    label: 'Validade',
    sortable: true,
    width: pxToRem(100)
  },
  batchCurrentStock: {
    label: 'Qtd. Estoque',
    sortable: true,
    width: pxToRem(70)
  },
  minimumStockWithMeasure: {
    label: 'Estoque Mínimo',
    sortable: true,
    width: pxToRem(100)
  },
  invoice_url: {
    label: 'NF',
    width: pxToRem(10),
    align: 'center',
  },
  certificate_url: {
    label: 'Certificado',
    width: pxToRem(10),
    align: 'center',
  },
  actions: {
    label: 'Ações',
    align: 'center',
    width: pxToRem(30)
  }
}

class Stock extends Component {
  constructor(props) {
    super(props)
    this.state = {
      debounce: undefined,
      openInputModal: false,
      openOutputModal: false,
      openHistoricModal: false,
      modalMethod: 'create',
      productName: '',
      productId: null,
      productBatch: null,
      inventory: {}
    }
  }

  componentDidMount() {
    this.props.fetchInventoryInputList(this.props.searchText, this.props.areaId)
  }

  componentWillUpdate({ searchText = '' }) {
    const { areaId, pagination } = this.props
    const { rowsPerPage, orderBy, order } = pagination
    const order_direction = order ? 'desc' : 'asc'
    const page = 1

    if (searchText !== this.props.searchText) {
      const debounce = setTimeout(() => {
        this.props.fetchInventoryInputList(searchText, areaId, page, rowsPerPage, orderBy, order_direction)
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidUpdate(prevProps) {
    const { areaId, fetchInventoryInputList, searchText, pagination } = this.props
    const { rowsPerPage, orderBy, order } = pagination
    const order_direction = order ? 'desc' : 'asc'
    const page = 1

    if (areaId && prevProps.areaId !== areaId) {
      const debounce = setTimeout(() => {
        fetchInventoryInputList(searchText, areaId, page, rowsPerPage, orderBy, order_direction)
      }, 400)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }
  }

  openModalInput = (row = undefined, method = 'create') => {
    if (row && row.id) {
      this.setInventory(row)
      this.setState(state => ({ openInputModal: true, modalMethod: method }))
    } else {
      this.clearInventoryState()
      this.setState(state => ({ openInputModal: true, modalMethod: method }))
    }
  }

  closeModalInput = () => {
    this.setState(state => ({
      openInputModal: false
    }))
  }

  setInventory(row) {
    const inventory = row
    this.setState(state => ({
      inventory: inventory
    }))
  }

  clearInventoryState() {
    const inventory = {}
    this.setState(state => ({
      inventory: inventory
    }))
  }

  openModalHistoric = async (
    row = undefined,
    areaId,
    page = 1,
    rowsPerPage = 10,
    orderBy = 'created_at',
    order = 'desc'
  ) => {
    const object = {
      product_id: row.product_id,
      batch: row.batch,
      areaId,
      page,
      rowsPerPage,
      orderBy,
      order
    }
    if (row && row.product_id) {
      await this.getHistoricModalData(object)
    } else {
      this.clearInventoryState()
    }
    this.setState(state => ({
      openHistoricModal: true,
      productId: row.product_id,
      productName: row.name,
      productBatch: row.batch
    }))
  }

  getHistoricModalData = async object => {
    const response = await inventoryActions.getProductHistoric(object)
    this.setState(state => ({
      historicData: response.items,
      paginationHistoric: response.pagination
    }))
  }

  closeModalHistoric = () => {
    this.setState(state => ({
      openHistoricModal: false
    }))
  }

  openModalOutput = (row = undefined, method = 'create') => {
    if (row && row.id) {
      this.setInventory(row)
    } else {
      this.clearInventoryState()
    }
    this.setState(state => ({ openOutputModal: true, modalMethod: method }))
  }

  closeModalOutput = () => {
    this.setState(state => ({
      openOutputModal: false
    }))
  }

  downloadXls = () => {
    this.props.fetchDownloadXls(this.props.searchText, this.props.areaId)
  }

  downloadPdf = () => {
    this.props.fetchDownloadPdf(this.props.searchText, this.props.areaId)
  }

  onChangeRowsPerPage = (rowsPerPage, currentPage = 1) => {
    this.props.fetchInventoryInputList(this.props.searchText, this.props.areaId, currentPage, rowsPerPage)
  }

  onChangePage = (newPage, rowsPerPage) => {
    this.props.fetchInventoryInputList(this.props.searchText, this.props.areaId, newPage, rowsPerPage)
  }

  onChangeOrderBy = (orderBy, order, currentPage = 1, rowsPerPage = 10) => {
    if (orderBy === 'batchCurrentStock') {
      orderBy = 'amount'
    }
    this.props.fetchInventoryInputList(this.props.searchText, this.props.areaId, currentPage, rowsPerPage, orderBy, order)
  }

  onChangeRowsPerPageHistoric = (
    rowsPerPage,
    currentPage = 1,
    orderBy = 'created_at',
    order = 'desc'
  ) => {
    const object = {
      product_id: this.state.productId,
      batch: this.state.productBatch,
      areaId: this.props.areaId,
      page: currentPage,
      rowsPerPage,
      orderBy,
      order
    }
    this.getHistoricModalData(object)
  }

  onChangePageHistoric = (newPage, rowsPerPage, orderBy = 'created_at', order = 'desc') => {
    const object = {
      product_id: this.state.productId,
      batch: this.state.productBatch,
      areaId: this.props.areaId,
      page: newPage,
      rowsPerPage,
      orderBy,
      order
    }
    this.getHistoricModalData(object)
  }

  onChangeOrderByHistoric = (orderBy, order, currentPage = 1, rowsPerPage = 10) => {
    if (orderBy === 'batchCurrentStock') {
      orderBy = 'amount'
    }
    const object = {
      product_id: this.state.productId,
      batch: this.state.productBatch,
      areaId: this.props.areaId,
      page: currentPage,
      rowsPerPage,
      orderBy,
      order
    }
    this.getHistoricModalData(object)
  }

  productFullName = product => {
    const provider =
      product && product.provider && product.provider !== '---'
        ? ' - (' + product.provider + ')'
        : ''
    return product.name + provider
  }

  openFile = url => {
    if (!!url) {
      window.open(url, '_blank')
    }
  }

  render() {
    const {
      router,
      menuItems,
      last_update,
      fetching,
      fetch_errors,
      areaId,
      inventoryInputList,
      fetchInventoryInputList,
      changeStatusDownloadError,
      pagination
    } = this.props

    const {
      openInputModal,
      inventory,
      modalMethod,
      openOutputModal,
      openHistoricModal,
      historicData,
      productName,
      productId,
      productBatch,
      paginationHistoric
    } = this.state

    const {
      downloadPdf,
      downloadXls,
      openModalInput,
      openModalOutput,
      closeModalInput,
      closeModalOutput,
      openModalHistoric,
      closeModalHistoric,
      onChangeRowsPerPage,
      onChangePage,
      onChangeOrderBy,
      onChangeRowsPerPageHistoric,
      onChangePageHistoric,
      onChangeOrderByHistoric,
      productFullName,
      openFile
    } = this

    const NameCellComponent = ({ name, value, row, ...rest }) => {
      return (
        <InventoryLink {...rest} onClick={e => openModalInput(row, 'edit')}>
          {value}
        </InventoryLink>
      )
    }

    columns['name'] = {
      ...columns['name'],
      CellComponent: NameCellComponent
    }

    const ActionsCellComponent = ({ name, value, row, ...rest }) => {
      return (
        <WrapperActions>
          <Action src={editIcon} onClick={e => openModalInput(row, 'edit')} />
          <Action src={historicIcon} onClick={e => openModalHistoric(row, areaId)} />
        </WrapperActions>
      )
    }

    columns['actions'] = {
      ...columns['actions'],
      CellComponent: ActionsCellComponent
    }

    const InvoiceCellComponent = ({ name, value, row, ...rest }) => {
      return (
        row && row.invoice_url === '---' ? (
          <WrapperStatus type="failure">
            <img src={statusWarningIcon} alt="NF Status" />
          </WrapperStatus>
        ) : (
          <WrapperStatus type="success">
            <Action src={statusSuccessIcon} onClick={e => openFile(row.invoice_url)} alt="NF Status" />
          </WrapperStatus>
        )
      )
    }

    columns['invoice_url'] = {
      ...columns['invoice_url'],
      CellComponent: InvoiceCellComponent
    }

    const CertificateCellComponent = ({ name, value, row, ...rest }) => {
      return (
        row && row.certificate_url === '---' ? (
          <WrapperStatus type="failure">
            <img src={statusWarningIcon} alt="Certificate Status" />
          </WrapperStatus>
        ) : (
          <WrapperStatus type="success">
            <Action src={statusSuccessIcon} onClick={e => openFile(row.certificate_url)} alt="Certificate Status" />
          </WrapperStatus>
        )
      )
    }

    columns['certificate_url'] = {
      ...columns['certificate_url'],
      CellComponent: CertificateCellComponent
    }

    return (
      <Fragment>
        <Grid>
          <Header search router={router} />
          <Sidebar menuItems={menuItems} router={router} />
          <Content scapeSearch>
            <ContentHeader
              title="Produtos Químicos"
              subtitle="Estoque"
              last_update={last_update}
            >
            </ContentHeader>
            {this.props.areaId === 'all' ? (
              <WarningWrapper>
                <strong>Você deve selecionar uma área para acessar esta funcionalidade.</strong>
              </WarningWrapper>
            ) : (
              <StockContent>
                <WrapperButton>
                  <WrapperExport>
                    <h2>Exportar Para: </h2>
                    <WrapperExportButton>
                      <ExportXls
                        onClick={e => {
                          downloadXls()
                        }}
                      >
                        EXCEL
                      </ExportXls>
                      |
                      <ExportPdf
                        onClick={e => {
                          downloadPdf()
                        }}
                      >
                        PDF
                      </ExportPdf>
                    </WrapperExportButton>
                  </WrapperExport>
                  <InputButton
                    onClick={e => {
                      openModalInput()
                    }}
                  >
                    Registrar Entrada
                  </InputButton>
                  <OutputButton
                    onClick={e => {
                      openModalOutput()
                    }}
                  >
                    Registrar Saída
                  </OutputButton>
                </WrapperButton>
                <Table
                  loading={fetching.inventoryInputList}
                  error={fetch_errors.inventoryInputList}
                  fetchData={fetchInventoryInputList}
                  onChangePage={(newPage, rowsPerPage, orderBy, order) =>
                    onChangePage(newPage, rowsPerPage, orderBy, order)
                  }
                  onChangeRowsPerPage={(rowsPerPage, currentPage, orderBy, order) =>
                    onChangeRowsPerPage(rowsPerPage, currentPage, orderBy, order)
                  }
                  onChangeOrderBy={(orderBy, order, currentPage, rowsPerPage) =>
                    onChangeOrderBy(orderBy, order, currentPage, rowsPerPage)
                  }
                  columns={columns}
                  height={'55vh'}
                  width={1100}
                  data={inventoryInputList.map(item => {
                    return {
                      ...item,
                      name: productFullName(item)
                    }
                  })}
                  pagination={pagination || {}}
                  defaultSort={{ key: 'created_at', reverse: true }}
                />
                <InventoryInputModal
                  title={
                    modalMethod === 'create'
                      ? 'Registrar Entrada de Produto'
                      : 'Editar Nota Fiscal da Entrada de Produto'
                  }
                  open={openInputModal}
                  closeMethod={closeModalInput}
                  method={modalMethod}
                  size="large"
                  loading={false}
                  inventoryItem={inventory}
                />
                <HistoricModal
                  title="Histórico do Produto"
                  open={openHistoricModal}
                  closeMethod={closeModalHistoric}
                  size="large"
                  loading={false}
                  historicData={historicData}
                  productId={productId}
                  productBatch={productBatch}
                  productName={productName}
                  pagination={paginationHistoric}
                  onEditOutput={row => {
                    closeModalHistoric()
                    openModalOutput(row, 'edit')
                  }}
                  onChangePage={(newPage, rowsPerPage) =>
                    onChangePageHistoric(newPage, rowsPerPage)
                  }
                  onChangeRowsPerPage={(rowsPerPage, currentPage) =>
                    onChangeRowsPerPageHistoric(rowsPerPage, currentPage)
                  }
                  onChangeOrderBy={(orderBy, order, currentPage, rowsPerPage) =>
                    onChangeOrderByHistoric(orderBy, order, currentPage, rowsPerPage)
                  }
                />
                <InventoryOutputModal
                  title={
                    modalMethod === 'edit'
                      ? 'Editar NF / Certificado da Saída'
                      : 'Registrar Saída de Produto'
                  }
                  open={openOutputModal}
                  closeMethod={closeModalOutput}
                  method={modalMethod}
                  size="large"
                  loading={false}
                  inventoryItem={inventory}
                />
                <Modal
                  title="Exportação PDF/EXCEL"
                  open={fetching.download}
                  closeMethod={fetching.download}
                  size="small"
                  loading={fetching.download}
                />
                <Modal
                  safeContent={false}
                  loading={false}
                  open={fetch_errors.download}
                  size={'small'}
                  error={true}
                  errorMessage={'Falha ao exportar o arquivo'}
                  closeMethod={changeStatusDownloadError}
                />
              </StockContent>
            )}
            <ResponsiblesContent />
          </Content>
        </Grid>
        <Modal
          safeContent={false}
          loading={false}
          open={fetch_errors.download}
          size={'small'}
          error={true}
          errorMessage={'Falha ao exportar o arquivo'}
          closeMethod={changeStatusDownloadError}
        />
        <Modal
          safeContent={false}
          loading={fetching.download}
          open={fetching.download}
          size={'small'}
          error={false}
        />
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  inventoryInputList: state.inventory.items,
  pagination: state.inventory.pagination,
  last_update: state.inventory.last_update,
  total_records: state.inventory.total_records,
  fetching: state.inventory.fetching,
  fetch_errors: state.inventory.fetch_errors,
  areaId: state.auth.areaId,
  searchText: state.search.searchText,
  can_change_area: state.auth.canChangeArea
})

const mapDispatchToProps = dispatch => {
  return {
    fetchInventoryInputList: (
      searchText,
      areaId,
      page = 1,
      rowsPerPage = 10,
      orderBy = 'created_at',
      order = 'desc'
    ) => {
      const object = { searchText, areaId, page, rowsPerPage, orderBy, order }
      dispatch(inventoryActions.fetchInventoryInputList(object))
    },
    fetchDownloadXls: (searchText, areaId) => {
      dispatch(inventoryActions.fetchDownloadXls(searchText, areaId))
    },
    fetchDownloadPdf: (searchText, areaId) => {
      dispatch(inventoryActions.fetchDownloadPdf(searchText, areaId))
    },
    changeStatusDownloadError: () => {
      dispatch(inventoryActions.changeStatusDownloadError())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Stock)



// WEBPACK FOOTER //
// ./src/containers/Inventory/Stock.js